import React, { useCallback, useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';

const MOMENTS_KEY = 'magic_moments';

export function saveMoment(moment) {
  try {
    const existing = JSON.parse(localStorage.getItem(MOMENTS_KEY) || '[]');
    const next = [{ id: Date.now(), ...moment }, ...existing].slice(0, 20);
    localStorage.setItem(MOMENTS_KEY, JSON.stringify(next));
    return next;
  } catch {
    return [];
  }
}

function readMoments() {
  try {
    return JSON.parse(localStorage.getItem(MOMENTS_KEY) || '[]');
  } catch {
    return [];
  }
}

/**
 * Global reusable "cart" of magic moments a participant has created (word tags + photo),
 * saved locally so they can revisit/remove them before finishing entry.
 */
const MomentsCart = ({ className = '' } = {}) => {
  const [moments, setMoments] = useState([]);

  useEffect(() => {
    setMoments(readMoments());
  }, []);

  const handleRemove = useCallback((id) => {
    setMoments((prev) => {
      const next = prev.filter((m) => m.id !== id);
      localStorage.setItem(MOMENTS_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  if (moments.length === 0) {
    return (
      <div className={`moments-cart moments-cart--empty ${className}`.trim()}>
        <p className="text-muted mb-0">No moments saved yet — create one from the home screen.</p>
      </div>
    );
  }

  return (
    <div className={`moments-cart ${className}`.trim()}>
      {moments.map((moment) => (
        <div key={moment.id} className="moments-cart-item">
          {moment.photo && <img src={moment.photo} alt="" className="moments-cart-item-photo" />}
          <div className="moments-cart-item-body">
            <div className="moments-cart-item-words">{(moment.words || []).join(', ') || 'Magic moment'}</div>
            {moment.productLine && <div className="moments-cart-item-product">{moment.productLine}</div>}
          </div>
          <button
            type="button"
            className="moments-cart-item-remove"
            onClick={() => handleRemove(moment.id)}
            aria-label="Remove moment"
          >
            <Trash2 size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default MomentsCart;
